export default "../img/bg-tabber-2.svg";